import React from 'react';
import { array, object } from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { isFiverrChoice } from '../../../utils/fiverrChoice';
import { isRisingTalent } from '../../../utils/risingTalent';

import classes from './index.module.scss';

const Badges = (props, {
    general,
    choiceEligibilities
}) => {
    const { queryParameters, abTests } = getContext();

    const showFiverrChoiceBadge = isFiverrChoice({ queryParameters, abTests, choiceEligibilities });

    const showRisingTalentBadge = isRisingTalent(general.isHandpicked);

    return (
        <>
            { showFiverrChoiceBadge &&
                <Tooltip containerClassName={classes.gigOverviewTooltipContainer}
                    boxContentClassName={classes.gigOverviewTooltipBoxContent}
                    content={<I18n k="gig_page_perseus.overview.fiverr_choice"/>}
                    position={Tooltip.POSITIONS.BOTTOM}>
                    <span className={classes.fiverrChoice}/>
                </Tooltip>
            }
            { !showFiverrChoiceBadge && showRisingTalentBadge &&
                <Tooltip containerClassName={classes.gigOverviewTooltipContainer}
                    boxContentClassName={classes.gigOverviewTooltipBoxContent}
                    content={translate('gig_page_perseus.overview.rising_talent.tooltip')}
                    position={Tooltip.POSITIONS.BOTTOM}>
                    <span className={classes.risingTalent}>
                        <I18n k="gig_page_perseus.overview.rising_talent.caption"/>
                    </span>
                </Tooltip>
            }
        </>
    );
};

Badges.contextTypes = {
    general: object,
    choiceEligibilities: array
};

export default Badges;
